import styled from '@emotion/styled'
import Head from 'next/head'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { Themed } from 'theme-ui'

import { Container } from '../components/UIComponents'
import { bakgrundEnglishLocale, bakgrundSwedishLocale } from '../locales'

/**
 * Renders the Bakgrund component.
 *
 * @returns {HTMLElement} - The HTML Markup.
 */
const Bakgrund = () => {
  const router = useRouter()
  const { locale } = router
  const t = locale === 'en' ? bakgrundEnglishLocale : bakgrundSwedishLocale

  return (
    <>
      <Head>
        <title>Bakgrund - JC Psykologmottagning AB</title>
        <meta
          name="Description"
          content="Mitt namn är Jonas Claesson. Jag är legitimerad psykolog sedan 1993 samt specialist inom klinisk psykologi sedan 2004"
        />
        <link rel="icon" href="/img/logo.svg" />
      </Head>
      <Container>
        <BakgrundStyles>
          <div className="col-md-9">
            <Themed.h1>{t.backgroundTitle}</Themed.h1>
            <Themed.p>{t.backgroundParagraphOne}</Themed.p>
            <Themed.p>{t.backgroundParagraphTwo}</Themed.p>
            <Themed.p>{t.backgroundParagraphThree}</Themed.p>
          </div>
          <div className="card-item">
            <Image src="/img/jonas.jpg" alt="Jonas" width={200} height={300} priority />
            <Themed.ul>
              <li>{t.listItemOne}</li>
              <li>{t.listItemTwo}</li>
              <li>{t.listItemThree}</li>
            </Themed.ul>
          </div>
        </BakgrundStyles>
      </Container>
    </>
  )
}

const BakgrundStyles = styled.section``

export default Bakgrund
